import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

interface Message {
    header?: string;
    message: string;
}

@Component({
    selector: 'app-info-dialog',
    templateUrl: './info-dialog.component.html',
    styleUrls: ['./info-dialog.component.scss'],
})
export class InfoDialogComponent {
    @Input() title: string = null;
    @Input() message: string = null;
    @Input() messages: Message[] = null;
    @Input() mode: string = 'general';
    @Input() helpLink: string = 'https://flumewater.com';

    constructor(public dialog: NbDialogRef<InfoDialogComponent>) {}
}
